import { createStore } from "owa-satcheljs";
import { getDefaultValue } from "../utils/exploreStoreUtils";

// Explore Page testing store
interface PlacesExploreDiagnosticsStore {
    devPageState: string | undefined;
    devErrorPageState: string | undefined;
    devComponentState: string | undefined;
}
const initializePlacesExploreDiagnosticsStore: PlacesExploreDiagnosticsStore = {
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function getDefaultValue called at module scope is not allowed. This may cause unwanted side effects. */
    devPageState: getDefaultValue("epageState"),
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function getDefaultValue called at module scope is not allowed. This may cause unwanted side effects. */
    devErrorPageState: getDefaultValue("epageError"),
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function getDefaultValue called at module scope is not allowed. This may cause unwanted side effects. */
    devComponentState: getDefaultValue("ecomponentState"),
};

let exploreStore: ReturnType<typeof createStore<PlacesExploreDiagnosticsStore>> | undefined;

export function getPlacesExploreDiagnosticsStore(): PlacesExploreDiagnosticsStore {
    if (!exploreStore) {
        /* eslint-disable-next-line owa-custom-rules/invoke-only-in-module-scope -- (https://aka.ms/OWALintWiki)
         * Baseline. DO NOT COPY AND PASTE!, this function can only be called in the module scope.
         *	> Function should only be invoked in module scope */
        exploreStore = createStore("PlacesExploreDiagnosticsStore", initializePlacesExploreDiagnosticsStore);
    }
    return exploreStore();
}
